import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Col, Table, Image, Button } from "react-bootstrap";
import moment from "moment";
import { FormControl, Select, InputLabel, MenuItem } from "@material-ui/core";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { RightSideCountTop } from "../superAdminReports/orderingReports/SuperAdminPendingOrderActivityReports";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { useFormik } from "formik";
import { SortComponent } from "../../../reusableComponents/SortAndFilterComponent/SortComponent";
import BasicPagination from "../../../Pagination/Pagination";

import propTypes from "prop-types";
import { admin_get_all_pending_activity } from "../../../../store/actions/SuperAdminActions/adminOrderingActivityDashboard";
import isEmpty from "../../../../store/validation/is-Empty";
import {
  ORDER_TYPE,
  PAYMENT_TYPE,
  PAYMENT_STATUS,
  NEW_PAYMENT_TYPE,
  ORDER_STATUS,
} from "../../../../enums/OrderEnums";
import NewCountDown from "../../../reusableComponents/allPopupReusable/tableNumberPopup/NewCountDown";
import {
  create_and_update_restaurant,
  get_new_subscription_for_vendor,
} from "../../../../store/actions/authAction";
import { useHistory } from "react-router-dom";
import { setVendorAccess } from "../../../../store/actions/vendorAccessActions";
import CSVDownloader from "../../../reusableComponents/csvDownload/csvDownload";
// Animations

import styled, { keyframes } from "styled-components";
import { zoomIn } from "react-animations";
import SelectFilter from "../../../reusableComponents/selectFilter";
import NoContent from "../../../reusableComponents/NoContentComponent";

const zoomAnimation = keyframes`${zoomIn}`;

const ZoomDiv = styled.div`
  animation: 1s ${zoomAnimation};
`;

// End Animations

function SuperAdminPendingOrders(props) {
  const dispatch = useDispatch();

  /***************************************
   * @DESC GET ADMIN INFORMATION
   **************************************/
  const auth = useSelector((state) => {
    return !isEmpty(state?.auth?.user) ? state?.auth?.user : "";
  });

  /***************************************
   * @DESC GET ALL ORDERING DATA
   **************************************/

  const allOrderingsActivity = useSelector((state) => {
    return !isEmpty(
      state?.superAdminOrderActivity?.admin_get_all_pending_activity?.orders
    )
      ? state?.superAdminOrderActivity?.admin_get_all_pending_activity?.orders
      : [];
  });

  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(50);
  const [dateQuery, setDateQuery] = useState({});

  const onDateChangeHandler = () => (data, type) => {
    setDateQuery(data);
  };

  const handleBatchChange = (pageNo) => {
    var calcStart = pageNo * 50 - 50;
    setStart(calcStart);
    setEnd(pageNo * 50);
    setPage(pageNo);
  };

  useEffect(() => {
    if (!isEmpty(dateQuery)) {
      dispatch(
        admin_get_all_pending_activity(
          auth.accessToken,
          dateQuery.startDate,
          dateQuery.endDate
        )
      );
    }
  }, [dateQuery]);

  /***************************************
   * @DESC ALL ORDER ACTIVITY COUNT
   **************************************/
  const activityCount = useSelector((state) => {
    return !isEmpty(
      state?.superAdminOrderActivity?.admin_get_all_pending_activity?.stats
    )
      ? state?.superAdminOrderActivity?.admin_get_all_pending_activity?.stats
      : "";
  });
  let takeAwayCount =
    activityCount && activityCount.findIndex((obj) => obj._id == 0);
  let curbSideCount =
    activityCount && activityCount.findIndex((obj) => obj._id == 1);
  let skipTheLineCount =
    activityCount && activityCount.findIndex((obj) => obj._id == 2);
  let dineInCount =
    activityCount && activityCount.findIndex((obj) => obj._id == 3);
  let homeDeliveryCount =
    activityCount && activityCount.findIndex((obj) => obj._id == 7);

  let totalCount =
    activityCount &&
    activityCount[takeAwayCount]?.count +
    activityCount[curbSideCount]?.count +
    activityCount[skipTheLineCount]?.count +
    activityCount[dineInCount]?.count +
    activityCount[homeDeliveryCount]?.count;

  let totalNewAmount =
    activityCount &&
    activityCount[takeAwayCount]?.totalAmount +
    activityCount[curbSideCount]?.totalAmount +
    activityCount[skipTheLineCount]?.totalAmount +
    activityCount[dineInCount]?.totalAmount +
    activityCount[homeDeliveryCount]?.totalAmount;

  const [state, setState] = useState({
    search: "",
    anchorEl: null,
    restaurantReverse: "",
    showFilter: false,
    orderStatusType: "",
    orderPaymentType: "",
    showSearch: false,
  });

  /*********************************
   * @DESC Search Bar Action
   *********************************/
  const onSearchChange = (e) => {
    setState({
      ...state,
      search: e.target.value,
    });
  };

  /*********************************
   * @DESC SORT FILTER ACTION
   *********************************/
  const handleClick = (event) => {
    setState({
      ...state,
      anchorEl: event.currentTarget,
    });
  };

  const handleClose = () => {
    setState({
      ...state,
      anchorEl: null,
    });
  };

  const handleSelect = (value) => () => {
    setState({
      ...state,
      restaurantReverse: value,
      anchorEl: false,
    });
  };

  /******************************************
   * @DESC FILTER BUTTON ACTION
   *****************************************/
  const handleShowFilter = () => {
    setState({
      ...state,
      showFilter: !state.showFilter,
    });
  };

  const SetFormikDataState = (data) => {
    setState({
      ...state,
      showFilter: false,
      orderStatusType: data.values.orderStatusType,
      orderPaymentType: data.values.orderPaymentType,
    });
  };

  const formik = useFormik({
    initialValues: {
      orderStatusType: "",
      orderPaymentType: "",
    },

    onSubmit: (values) => {
      formik.orderStatusType = values.orderStatusType;
      formik.orderPaymentType = values.orderPaymentType;
      SetFormikDataState(formik);
    },
  });

  const [count, setCount] = useState(1);
  const onClickSave = (e) => {
    e.preventDefault();
    setCount(count + 1);
    formik.handleSubmit();
  };

  /*************************************************
   * @DESC TABLE BODY COMPONENT FUNCTION
   *************************************************/
  const RenderTableBody = () => {
    const smsDataArr = allOrderingsActivity && allOrderingsActivity;
    let filteredData = [];
    if (state.restaurantReverse === "A-Z") {
      filteredData = smsDataArr.sort((a, b) => {
        if (
          a?.user_details?.first_name + " " + a?.user_details?.last_name <
          b?.user_details?.first_name + " " + b?.user_details?.last_name
        )
          return -1;
        if (
          a?.user_details?.first_name + " " + a?.user_details?.last_name >
          b?.user_details?.first_name + " " + b?.user_details?.last_name
        )
          return 1;
        return 0;
      });
    } else if (state.restaurantReverse === "Z-A") {
      filteredData = smsDataArr.sort((a, b) => {
        if (
          a?.user_details?.first_name + " " + a?.user_details?.last_name <
          b?.user_details?.first_name + " " + b?.user_details?.last_name
        )
          return 1;
        if (
          a?.user_details?.first_name + " " + a?.user_details?.last_name >
          b?.user_details?.first_name + " " + b?.user_details?.last_name
        )
          return -1;
        return 0;
      });
    }
    if (state.search) {
      let search = new RegExp(state.search, "i");
      filteredData = smsDataArr.filter((getall) => {
        if (
          search.test(
            getall?.user_details?.first_name +
            " " +
            getall?.user_details?.last_name
          )
        ) {
          return getall;
        } else if (search.test(getall?.restaurant_id?.restaurant_name)) {
          return getall;
        } else {
          return false;
        }
      });
    } else if (state.orderStatusType !== "") {
      filteredData = smsDataArr.filter(
        (notification) => notification.order_type === state.orderStatusType
      );
    } else if (state.orderPaymentType !== "") {
      filteredData = smsDataArr.filter(
        (notification) => notification.payment_method === state.orderPaymentType
      );
    } else {
      filteredData = smsDataArr;
    }
    if (!isEmpty(filteredData)) {
      return filteredData.slice(start, end).map((data, index) => (
        <React.Fragment key={index}>
          <TableBody orderInfo={data} />
        </React.Fragment>
      ));
    }
  };

  const downloadData = {
    headers: [
      { label: "Restaurant Name", key: "name" },
      { label: "ID", key: "id" },
      { label: "Order Type", key: "orderType" },
      { label: "User Name", key: "name" },
      { label: "Order Id", key: "orderId" },
      { label: "No of Items", key: "no" },
      { label: "Amount", key: "amount" },
      { label: "Order Date", key: "date" },
      { label: "Stauts", key: "status" },
    ],
    data: allOrderingsActivity
      ? allOrderingsActivity?.map((ele) => {
        return {
          name: ele?.restaurant_id?.restaurant_name,
          id: ele?.restaurant_id?._id,
          orderType: ORDER_TYPE[ele?.order_type],
          name: `${ele?.user_details?.first_name} ${ele?.user_details?.last_name}`,
          orderId: ele?.order_id,
          no: ele?.order_items?.length || 0,
          amount: ele?.total_amount,
          date: moment(ele?.createdAt).format("lll"),
          status: ORDER_STATUS[ele?.order_status],
        };
      })
      : [],
  };

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation displayText="Reports" />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                  Pending Order Activity Dashboard
                </div>
              </div>
              <div>
                <div className="d-flex justify-content-between mt-3 mb-3">
                  <div>
                    <div
                      style={{
                        borderRadius: "50%",
                        border: "1px solid #EE3A23",
                        padding: "10px",
                      }}
                    >
                      <img
                        width="45px"
                        src={require("../../../../assets/images/seatingImages/newpendingicon.svg")}
                      />
                    </div>
                    <div
                      className="f12-500"
                      style={{ color: "#EE3A23" }}
                      align="center"
                    >
                      Pending
                    </div>
                  </div>
                  <RightSideCountTop
                    content={[
                      {
                        name: "Home Delivery Order / Amount",
                        loader: allOrderingsActivity && allOrderingsActivity.length >= 0
                          ? false
                          : true,
                        value: allOrderingsActivity?.length <= 0 ? '-' : `${activityCount &&
                          activityCount[homeDeliveryCount]?.count !== undefined
                          ? activityCount &&
                          activityCount[homeDeliveryCount]?.count
                          : "0"
                          } /₹ ${activityCount &&
                            activityCount[homeDeliveryCount]?.totalAmount !==
                            undefined
                            ? activityCount &&
                            activityCount[
                              homeDeliveryCount
                            ]?.totalAmount.toFixed(2)
                            : "0"
                          }`,
                        backgroundColor: "#FFEDE9",
                        color: "#EE3A23",
                      },
                      {
                        name: "Curbside Orders/Amount",
                        loader:
                          allOrderingsActivity &&
                            allOrderingsActivity.length >= 0
                            ? false
                            : true,
                        value: allOrderingsActivity?.length <= 0 ? '-' : `${activityCount && activityCount[curbSideCount]?.count
                          } /₹ ${activityCount &&
                          activityCount[curbSideCount]?.totalAmount.toFixed(2)
                          }`,
                        backgroundColor: "#EFEBFB",
                        color: "#6F32C9",
                      },
                      {
                        name: "Dine-In Orders/Amount",
                        loader:
                          allOrderingsActivity &&
                            allOrderingsActivity.length >= 0
                            ? false
                            : true,
                        value: allOrderingsActivity?.length <= 0 ? '-' : `${activityCount && activityCount[dineInCount]?.count
                          } /₹ ${activityCount &&
                          activityCount[dineInCount]?.totalAmount.toFixed(2)
                          }`,
                        backgroundColor: "#D8F3F4",
                        color: "#138B90",
                      },
                      {
                        name: "Skip the Line Order /Amount",
                        loader:
                          allOrderingsActivity &&
                            allOrderingsActivity.length >= 0
                            ? false
                            : true,
                        value: allOrderingsActivity?.length <= 0 ? '-' : `${activityCount &&
                          activityCount[skipTheLineCount]?.count
                          } /₹ ${activityCount &&
                          activityCount[skipTheLineCount]?.totalAmount.toFixed(
                            2
                          )
                          }`,
                        backgroundColor: "#FFEDE9",
                        color: "#EE3A23",
                      },
                      {
                        name: "Take Away Orders/Amount",
                        loader:
                          allOrderingsActivity &&
                            allOrderingsActivity.length >= 0
                            ? false
                            : true,
                        value: allOrderingsActivity?.length <= 0 ? '-' : `${activityCount && activityCount[takeAwayCount]?.count
                          } /₹ ${activityCount &&
                          activityCount[takeAwayCount]?.totalAmount.toFixed(2)
                          }`,
                        backgroundColor: "#EFEBFB",
                        color: "#6F32C9",
                      },
                      {
                        name: "Total number of Orders",
                        loader:
                          allOrderingsActivity &&
                            allOrderingsActivity.length >= 0
                            ? false
                            : true,
                        // value: `${totalCount} /₹ ${
                        //   totalNewAmount && totalNewAmount.toFixed(2)
                        // }`,
                        value: allOrderingsActivity?.length <= 0 ? '-' : `${isNaN(totalCount) === true ? "0" : totalCount
                          } /₹ ${totalNewAmount && totalNewAmount !== undefined
                            ? totalNewAmount && totalNewAmount.toFixed(2)
                            : "0"
                          }`,
                        backgroundColor: "#D8F3F4",
                        color: "#138B90",
                      },
                    ]}
                  />
                </div>
              </div>
              <hr />
              <div className="row">
                <div className="col-5 d-flex align-items-end">
                  <Image
                    onClick={() =>
                      // this.setState({ showSearch: !this.state.showSearch })
                      setState({
                        ...state,
                        showSearch: !state.showFilter,
                      })
                    }
                    alt="filter"
                    title="filter"
                    width="95px"
                    src={require("../../../../assets/images/iconButton/newsearchicon.svg")}
                  />
                  <div className="w-100 d-flex align-items-center ">
                    <div
                      className="f10-400"
                      align="center"
                      onClick={() => handleShowFilter()}
                    >
                      <img
                        src={require("../../../../assets/images/seatingImages/filter.svg")}
                        width="80px"
                      />
                      <br />
                      {/* Filter */}
                    </div>
                    <SortComponent
                      handleClick={handleClick}
                      anchorEl={state.anchorEl}
                      handleClose={handleClose}
                      selectClick={(data) => handleSelect(data)}
                    />
                    <CSVDownloader
                      filename={"pendingOrders"}
                      headers={downloadData.headers}
                      data={downloadData.data}
                    />
                  </div>
                </div>
                <div className="col-5 d-flex align-items-end">
                  <div className="row w-100">
                    <div className="col-3"></div>
                  </div>
                </div>
                <div className="col-2 d-flex align-items-center">
                  <SelectFilter
                    onDateChange={onDateChangeHandler()}
                    defaultSelected={"TODAY"}
                  />
                </div>
              </div>
              {state.showSearch && (
                <div className="mb-3">
                  <ZoomDiv>
                    <>
                      <br />
                      <Form.Control
                        type="text"
                        placeholder="Search by business name, diner name"
                        name="search"
                        onChange={onSearchChange}
                        value={state.search}
                        className="amSearch"
                      />
                    </>
                  </ZoomDiv>
                </div>
              )}
              {state.showFilter && (
                <div className="row">
                  <div className="col-12">
                    <div className="enWhiteBox mt-3">
                      <Form className="row justify-content-between">
                        <Col md={5}>
                          <Form.Group>
                            <FormControl variant="outlined" className="w-100">
                              <InputLabel htmlFor="outlined-Restaurant-type">
                                Order Type
                              </InputLabel>
                              <Select
                                value={formik.values.orderStatusType}
                                onChange={formik.handleChange}
                                label="User Type"
                                onBlur={formik.handleBlur}
                                inputProps={{
                                  name: "orderStatusType",
                                  id: "orderStatusType",
                                }}
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                {ORDER_TYPE.map((data, index) => {
                                  return (
                                    <MenuItem value={index} key={index}>
                                      {data}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </FormControl>
                          </Form.Group>
                        </Col>
                        <Col md={5}>
                          <Form.Group>
                            <FormControl variant="outlined" className="w-100">
                              <InputLabel htmlFor="outlined-Restaurant-type">
                                Payment Type
                              </InputLabel>
                              <Select
                                value={formik.values.orderPaymentType}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                label="Status"
                                inputProps={{
                                  name: "orderPaymentType",
                                  id: "orderPaymentType",
                                }}
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                {PAYMENT_TYPE.map((data, index) => {
                                  return (
                                    <MenuItem value={index} key={index}>
                                      {data}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </FormControl>
                          </Form.Group>
                        </Col>

                        <Col md={12}>
                          <div className="d-flex align-items-center">
                            <Button
                              variant="outline-secondary"
                              className="btn-lg mr-4 px-5"
                              onClick={() => handleShowFilter()}
                            >
                              Reset
                            </Button>
                            <Button
                              variant="danger"
                              className="btn-lg px-5"
                              onClick={(e) => onClickSave(e)}
                            >
                              Apply Filter
                            </Button>
                          </div>
                        </Col>
                      </Form>
                    </div>
                  </div>
                </div>
              )}
              <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
                <Table className="HideShowTable enMinWidth900">
                  <thead>
                    <tr className="super_admin_all_users_table_head">
                      <td style={{ width: "20%" }} className="f12-400">
                        Business <br />
                        Name/ID
                      </td>
                      <td style={{ width: "6%" }} className="f12-400">
                        Order <br />
                        Type
                      </td>
                      <td style={{ width: "12%" }} className="f12-400">
                        Name / <br />
                        Request Number
                      </td>
                      <td style={{ width: "7%" }} className="f12-400">
                        No. <br />
                        Items
                      </td>
                      <td style={{ width: "10%" }} className="f12-400">
                        Amount / <br />
                        Payment
                      </td>
                      <td style={{ width: "10%" }} className="f12-400">
                        Order <br />
                        Reference
                      </td>
                      <td style={{ width: "10%" }} className="f12-400">
                        Req. Date / <br />
                        Time/Timer
                      </td>
                      <td
                        style={{ width: "15%", textAlign: "center" }}
                        className="f12-400"
                      >
                        Status
                      </td>
                      <td
                        style={{ width: "15%", textAlign: "center" }}
                        className="f12-400"
                      >
                        Actions
                      </td>
                    </tr>
                  </thead>
                  {allOrderingsActivity.length > 0 ? RenderTableBody() : <NoContent />}
                </Table>
              </div>
              {state.search !== "" ||
                state.orderStatusType !== "" ||
                state.orderPaymentType !== "" ? (
                ""
              ) : (
                <div className="row">
                  <div className="col-12">
                    {allOrderingsActivity.length !== 0 ? (
                      <BasicPagination
                        totalRecords={allOrderingsActivity.length}
                        limit={50}
                        batch={page}
                        onBatchChange={(e) => handleBatchChange(e)}
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

SuperAdminPendingOrders.propTypes = {
  admin_get_all_activity: propTypes.func.isRequired,
};

export default SuperAdminPendingOrders;

const TableBody = (props) => {
  let orderType =
    ORDER_TYPE &&
    ORDER_TYPE.filter((obj, index) => index === props.orderInfo?.order_type);

  let paymentType =
    PAYMENT_TYPE &&
    PAYMENT_TYPE.filter(
      (obj, index) => index === props.orderInfo?.payment_method
    );

  let paymentStatus =
    PAYMENT_STATUS &&
    PAYMENT_STATUS.filter(
      (obj, index) => index === props.orderInfo?.payment_status
    );
  let orderStatus =
    ORDER_STATUS &&
    ORDER_STATUS.filter(
      (obj, index) => index === props.orderInfo?.order_status
    );

  const createdAt = new Date(props.orderInfo?.createdAt);
  const updatedTime = moment(
    props.orderInfo?.max_time_date || props.orderInfo?.OrderAcceptTime
  ).add(parseInt(props.orderInfo?.max_time), "minutes");
  let diff = updatedTime.diff(moment());
  const seatedTime = new Date(props.orderInfo?.OrderAcceptTime);
  var endSeatedTime = moment(seatedTime).format("YYYY-MM-DDTHH:mm");
  var startTimeNew = moment(createdAt).format("YYYY-MM-DDTHH:mm");
  let dateOneSeated = new Date(startTimeNew);
  let dateTwoSeated = new Date(endSeatedTime);
  let msDifferenceSeated = dateTwoSeated - dateOneSeated;
  let minutesSeated = Math.floor(msDifferenceSeated / 1000 / 60);
  function seated_time_difference() {
    let StartedTime = new Date(props.orderInfo?.OrderAcceptTime).getTime();
    let EndedTime = new Date(props.orderInfo?.OrderCompleteTime).getTime();
    let difference = EndedTime - StartedTime;
    let hourss = Math.floor(difference / 3.6e6);
    let minutess = Math.floor((difference % 3.6e6) / 6e4);
    return hourss + " hh : " + minutess + " mins";
  }

  const dispatch = useDispatch();
  const history = useHistory();
  const onViewDashboard = () => {
    history.push("/orderdashboard/11");
  };

  const vendorDashboard = (id) => () => {
    dispatch(create_and_update_restaurant({ vendor_id: id }));
    dispatch(get_new_subscription_for_vendor({ vendor_id: id }));
    dispatch(setVendorAccess(id, onViewDashboard));
  };

  return (
    <tbody className="seating-dashboard-body-new">
      <tr className="super_admin_all_users_table_body">
        <td style={{ width: "20%" }} className="f12-500">
          <div className="super-admin-suggestion-table-body-boxone d-flex align-items-center">
            <div className="super-admin-suggestion-imageBoxOne enIMG33">
              {/* w-50 */}
              <img
                src={
                  props.orderInfo?.restaurant_id?.logo_url !== undefined &&
                    props.orderInfo?.restaurant_id?.logo_url !== null &&
                    props.orderInfo?.restaurant_id?.logo_url !== ""
                    ? props.orderInfo?.restaurant_id?.logo_url
                    : require("../../../../assets/images/ActionImages/demoprofile.jpg")
                }
                alt="Icon"
                title={props.orderInfo?.restaurant_id?.restaurant_name}
                className="img-fluid rounded-circle"
              />
            </div>
            <div className="super-admin-suggestion-imageBoxTwo ml-2">
              <div className="f12-500">
                {props.orderInfo?.restaurant_id?.restaurant_name}
              </div>
              <div className="f11-400">
                {props.orderInfo?.restaurant_id?.area}
              </div>
            </div>
          </div>
        </td>
        <td style={{ width: "6%" }} className="f12-500">
          {orderType &&
            orderType.map((data, index) => {
              return (
                <React.Fragment key={index}>
                  <Image
                    src={
                      data === "TAKEAWAY"
                        ? require("../../../../assets/images/Orders/nTakeaway.svg")
                        : data === "CURBSIDE"
                          ? require("../../../../assets/images/Orders/nCurbSide.svg")
                          : data === "SKIPTHELINE"
                            ? require("../../../../assets/images/Orders/nSkiptheline.svg")
                            : data === "DINEIN"
                              ? require("../../../../assets/images/Orders/nDineIn.svg")
                              : data === "BUFFET"
                                ? require("../../../../assets/images/Orders/Buffet.svg")
                                : data === "CATERING"
                                  ? require("../../../../assets/images/Orders/catering.svg")
                                  : data === "DRIVETHRU"
                                    ? require("../../../../assets/images/Orders/Drive thru.svg")
                                    : data === "HOMEDELIVERY"
                                      ? require("../../../../assets/images/Orders/Home delivery new icon.svg")
                                      : ""
                    }
                    alt={
                      data === "TAKEAWAY"
                        ? "TAKEAWAY"
                        : data === "CURBSIDE"
                          ? "CURBSIDE"
                          : data === "SKIPTHELINE"
                            ? "SKIPTHELINE"
                            : data === "DINEIN"
                              ? "DINEIN"
                              : data === "BUFFET"
                                ? "BUFFET"
                                : data === "CATERING"
                                  ? "CATERING"
                                  : data === "DRIVETHRU"
                                    ? "DRIVETHRU"
                                    : data === "HOMEDELIVERY"
                                      ? "HOMEDELIVERY"
                                      : ""
                    }
                    title={
                      data === "TAKEAWAY"
                        ? "TAKEAWAY"
                        : data === "CURBSIDE"
                          ? "CURBSIDE"
                          : data === "SKIPTHELINE"
                            ? "SKIPTHELINE"
                            : data === "DINEIN"
                              ? "DINEIN"
                              : data === "BUFFET"
                                ? "BUFFET"
                                : data === "CATERING"
                                  ? "CATERING"
                                  : data === "DRIVETHRU"
                                    ? "DRIVETHRU"
                                    : data === "HOMEDELIVERY"
                                      ? "HOMEDELIVERY"
                                      : ""
                    }
                    width="30px"
                  />
                </React.Fragment>
              );
            })}
        </td>
        <td style={{ width: "12%" }}>
          <p
            style={{
              fontSize: "14px",
            }}
            className="f12-500"
          >
            {props.orderInfo?.user_details?.first_name +
              " " +
              props.orderInfo?.user_details?.last_name}
          </p>
          <div className="f10-400">#{props.orderInfo?.order_id}</div>
        </td>
        <td style={{ width: "7%", textAlign: "center" }} className="f12-500">
          <div className="f14-500">
            {props.orderInfo?.order_items[0]?.quantity || 0}
          </div>
        </td>
        <td style={{ width: "14%" }}>
          <p className="f10-500 d-flex">
            ₹ {props.orderInfo?.total_amount?.toFixed(2) || 0} |
            {paymentStatus &&
              paymentStatus.map((data, index) => {
                return (
                  <React.Fragment key={index}>
                    <div className="pb-2 f8-700" style={{ color: "#3E9121" }}>
                      {data}
                    </div>
                  </React.Fragment>
                );
              })}
          </p>
          <hr className="mt-2 mb-2" />
          {/* {paymentType &&
            paymentType.map((data, index) => {
              return (
                <React.Fragment key={index}>
                  <div className="f12-500">{data}</div>
                </React.Fragment>
              );
            })} */}
          <div className="f12-500">
            {props?.orderInfo?.transactionDetails.map((data, index) => {
              return <>{NEW_PAYMENT_TYPE[data?.paymentType]} </>;
            })}
          </div>
        </td>
        <td style={{ width: "10%" }} className="f12-500">
          {orderType &&
            orderType.map((data, index) => {
              return (
                <React.Fragment key={index}>
                  {data === "TAKEAWAY" ? (
                    <p className="f12-500">Self Pick-up</p>
                  ) : data === "CURBSIDE" ? (
                    <div>
                      <p className="f12-500">
                        {props.orderInfo?.curb_side_details?.vehical_number
                          ? props.orderInfo?.curb_side_details?.vehical_number
                          : "_"}
                      </p>
                      <p
                        className="f10-500 mt-2 mb-1"
                        style={{ color: "#9E9E9E" }}
                      >
                        {props.orderInfo?.curb_side_details?.vehical_type_value
                          ? props.orderInfo?.curb_side_details
                            ?.vehical_type_value
                          : ""}{" "}
                        {props.orderInfo?.curb_side_details?.model
                          ? props.orderInfo?.curb_side_details?.model
                          : ""}{" "}
                        {props.orderInfo?.curb_side_details?.vehical_number
                          ? props.orderInfo?.curb_side_details?.vehical_number
                          : ""}
                      </p>
                      <p
                        className="f10-500 mt-2 mb-1"
                        style={{ color: "#9E9E9E" }}
                      >
                        {props.orderInfo?.curb_side_details?.make
                          ? props.orderInfo?.curb_side_details?.make
                          : ""}{" "}
                        {props.orderInfo?.curb_side_details?.year
                          ? props.orderInfo?.curb_side_details?.year
                          : ""}{" "}
                        {props.orderInfo?.curb_side_details?.color
                          ? props.orderInfo?.curb_side_details?.color
                          : ""}
                      </p>
                      {/* <p className="f10-400">Amanora Mall, Gate No. 3</p> */}
                    </div>
                  ) : data === "SKIPTHELINE" ? (
                    <p className="f12-500">Self Pick-up</p>
                  ) : data === "DINEIN" ? (
                    <p className="f12-500">
                      {props.orderInfo?.dine_in_details?.table_number
                        ? `Table No. ${props.orderInfo?.dine_in_details?.table_number}`
                        : "_"}
                    </p>
                  ) : data === "BUFFET" ? (
                    <p className="f12-500">N/A</p>
                  ) : data === "CATERING" ? (
                    <p className="f12-500">N/A</p>
                  ) : data === "DRIVETHRU" ? (
                    <p className="f12-500">N/A</p>
                  ) : data === "HOMEDELIVERY" ? (
                    <p className="f12-500">N/A</p>
                  ) : (
                    ""
                  )}
                </React.Fragment>
              );
            })}
        </td>
        <td style={{ width: "10%" }} className="f12-500">
          {/* <div className="f14-500" style={{ color: "#EE3A23" }}>
            12:15:22
          </div> */}
          <div className="date-time-timer-body">
            <div className="time-and-edit-button">
              <div className="timer-section mr-2">
                <h4
                  className="timer-count f14-500"
                  style={{ color: "#EE3A23" }}
                >
                  {props?.orderInfo && props?.orderInfo?.order_status === 0 ? (
                    "00:00:00"
                  ) : (
                    <NewCountDown waitNew={diff} />
                  )}
                </h4>
              </div>
            </div>
          </div>
          <div className="f12-400">
            {moment(props.orderInfo?.createdAt).format("Do-MMM-YYYY")} <br />
            {moment(props.orderInfo?.createdAt).format("hh:mm A")}
          </div>
        </td>
        <td style={{ width: "15%", textAlign: "center" }}>
          <p className="font_16_r">
            {/* Status:&nbsp; */}
            {orderStatus &&
              orderStatus.map((data, index) => {
                return (
                  <React.Fragment key={index}>
                    <span className="font_16_r">{data}</span>
                  </React.Fragment>
                );
              })}
          </p>
          {/* <div className="seating-dashboard-body-new">
            <div className="action-section-body">
              {/* <div className="middle-timer"> */}
          {/* <p className="font_12_r mb-2">Total Wait time</p>
                <div className="count-down-timer d-flex">
                  <i
                    className="fa fa-hourglass-half mr-3"
                    aria-hidden="true"
                  ></i>
                  <p className="font_16_m">
                    {seated_time_difference(minutesSeated)}
                  </p>
                </div> */}

          {/* </div> *
            </div>
          </div> */}
          {/* <p className="f12-500">{props.orderInfo?.diner_status}</p> */}
        </td>
        <td style={{ width: "15%" }}>
          <div
            className="p-2 f10-700"
            style={{
              border: "1px solid rgb(238, 58, 35)",
              borderRadius: "5px",
              cursor: "pointer",
            }}
            onClick={vendorDashboard(props.orderInfo?.vendor_id)}
          >
            <Image
              src={require("../../../../assets/images/ActionImages/image/onboarding.svg")}
              alt="View"
              title="View"
              fluid
              className="mr-2"
              width="20px"
            />
            View Dashboard
          </div>
        </td>
      </tr>
    </tbody>
  );
};
